export default __webpack_public_path__ + "static/media/detail_mobile_11_4.e60985e2.jpg";